import PropTypes from 'prop-types'
import React from 'react'
import HourCitizenField from '../question_fields/HourCitizenField'

const Citizen = props => {
  const { index, name, question, disabled = false, margin } = props
  return <HourCitizenField index={index} {...question} name={name} disabled={disabled} margin={margin} />
}

const HourQuestion = {
  Citizen,
  name: 'HourQuestion'
}

export default HourQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
